import*as React from'react';import*as PropTypes from'prop-types';var Context=React.createContext(null);/**
 * Tab Context Provider
 * @param {Object} props props
 * @returns {JSX}
 */var TabContext=function TabContext(props){var children=props.children,value=props.value;var context=React.useMemo(function(){return{value:value};},[value]);return React.createElement(Context.Provider,{value:context},children);};/**
 * @returns {unknown}
 */export var useTabContext=function useTabContext(){return React.useContext(Context);};export{TabContext};